import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './utils/AuthContext';
import Login from './pages/Login';
import Onboarding from './pages/Onboarding';
import Home from './pages/Home';
import SessionDetail from './pages/SessionDetail';
import GalleryView from './pages/GalleryView';
import Settings from './pages/Settings';
import StaffLogin from './pages/StaffLogin';
import StaffDashboard from './pages/StaffDashboard';
import ForgotPassword from './pages/ForgotPassword';
import NotFound from './pages/NotFound';
import './styles/global.css';

const PrivateRoute = ({ children }) => {
  const { client, loading } = useAuth();
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: 'var(--text-soft)', fontFamily: 'Nunito, sans-serif' }}>Loading...</div>;
  return client ? children : <Navigate to="/login" />;
};

const StaffRoute = ({ children }) => {
  const token = localStorage.getItem('staffToken');
  return token ? children : <Navigate to="/staff/login" />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Client routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/welcome" element={<Onboarding />} />
          <Route path="/gallery/:token" element={<GalleryView />} />
          <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/sessions/:id" element={<PrivateRoute><SessionDetail /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
          {/* Staff routes */}
          <Route path="/staff/login" element={<StaffLogin />} />
          <Route path="/staff" element={<StaffRoute><StaffDashboard /></StaffRoute>} />
          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
